// extracted by mini-css-extract-plugin
export default {"scrollArrow":"scrollArrow__vVMZ5E3S5B","scrollArrowContent":"scrollArrowContent__sgFP7VQyW9"};